module.exports = __webpack_public_path__ + "static/media/insolvency-restructuring-lion.139fb69b.jpg";